export default {
    bg: require('../assets/images/catch.forest.jpg'),
    sprites: [{
        image: require('../assets/images/catch.elephant.png'),
        x: 53,
        y: 39,
        rot: -5,
        scale: .7,
    }, {
        image: require('../assets/images/catch.deer.png'),
        x: 11,
        y: 37,
        rot: 4,
        scale: .8,
    }, {
        image: require('../assets/images/catch.net.png'),
        x: 62,
        y: 21,
        rot: -50,
        scale: .5,
    }],
}